import React from "react";
import LoginPanel from "@/components/dashboard/LoginPanel";

/**
 * AuthGate — shows a centered LoginPanel until /api/me resolves to ok:true.
 * On `me === undefined` (still loading), shows a brutalist skeleton.
 */
export default function AuthGate({ me, children }) {
  if (me === undefined) {
    return (
      <div
        data-testid="auth-loading"
        className="min-h-screen bg-[#FDFBF7] flex items-center justify-center"
      >
        <div className="font-accent text-sm text-[#0a0a0a]/60 animate-pulse">
          Loading your dashboard…
        </div>
      </div>
    );
  }

  if (me?.ok !== true) {
    return (
      <div
        data-testid="auth-locked"
        className="min-h-screen bg-[#FDFBF7] bg-grid flex flex-col"
      >
        <header className="border-b-4 border-[#0a0a0a] bg-[#FDFBF7]">
          <div className="max-w-[1400px] mx-auto px-5 md:px-10 h-[72px] flex items-center justify-between">
            <a
              href="/"
              className="inline-flex items-center gap-2 font-display text-xl md:text-2xl"
            >
              <img
                src="/jobhacki-logo.png"
                alt="JobHacki"
                className="h-9 w-9 border-2 border-[#0a0a0a] rounded-md object-cover"
              />
              JOBHACKI
            </a>
            <a
              href="/"
              className="font-accent text-xs md:text-sm text-[#0a0a0a]/70 hover:text-[#0a0a0a]"
            >
              ← back to home
            </a>
          </div>
        </header>
        <main className="flex-1 flex items-center justify-center px-5 py-16 md:py-24">
          <div className="w-full max-w-md">
            <div className="font-accent text-xs bg-[#E10600] text-white inline-block px-2.5 py-1 mb-4">
              SIGN IN TO CONTINUE
            </div>
            <LoginPanel source="dashboard" />
          </div>
        </main>
      </div>
    );
  }

  return children;
}
